import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpInterceptor} from "@angular/common/http";
import {HttpEvent} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {HttpHandler} from "@angular/common/http";
import {HttpRequest} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {AuthService} from "./auth.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cloneRequest = request.clone({
      withCredentials: true
    })


    // @ts-ignore
    return next.handle(cloneRequest)
      .pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const authService = this.injector.get(AuthService);
          authService.logout();
        }
        return throwError(error)
      })
    );

  }
}
